import * as React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, MenuItem, Typography } from '@mui/material';

export const ViewListItem = ({ view, viewId, selected, onDelete, onSelect, ...other }) => {
  return (
    <MenuItem selected={selected} onClick={() => onSelect(viewId)} {...other}>
      <Typography
        sx={{
          maxWidth: '700px',
          height: 'fit-content',
          display: 'block',
          whiteSpace: 'normal',
          wordBreak: 'break-word'
        }}
      >
        {view.label}
      </Typography>
      <IconButton
        edge="end"
        aria-label="delete"
        size="small"
        onClick={event => {
          event.stopPropagation();
          onDelete(viewId);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </MenuItem>
  );
};
